import React, { useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import { Modal as AntModal } from "antd";
import { toast } from "react-toastify";
import Modal from "react-modal";

const StockUploadList = (props) => {
  const { addForm, update, sId } = props;
  const [data, setData] = useState([]);
  const [allData, setAllData] = useState([]);
  const [itemsPerPage] = useState(10);  

  const { sendRequest: getDataList } = useHttp();

  const FillDetail = () => {
    getDataList(
      {
        url: `/api/openingStock/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          console.log(res);
          setData(res);
          setAllData(res);
        }
      }
    );
  };

  useEffect(() => {
    FillDetail();
  }, [getDataList]);

  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };



  const handleSearch = (e) => {
      var filetrtext = e.target.value.trim().toLowerCase();

    var filterdata = allData.filter(
      (item) =>
        item.cropName.toLowerCase().includes(filetrtext) ||
        item.varietyName.toLowerCase().includes(filetrtext) ||
        item.unitAbbreviation.toLowerCase().includes(filetrtext)
    );

   setData(filterdata); 
                                
setCurrentPage(1);
  };

  const [loginUserId, setLoginUserId] = useState(localStorage.getItem("id"));
  const [canAdd, setCanAdd] = useState("none");
  const [canEdit, setCanEdit] = useState("none");
  const [canDelete, setCanDelete] = useState("none");
  const [canPdf, setCanPdf] = useState("none");
  const [canView, setCanView] = useState("none");
  const [serviceId, setServiceId] = useState("none");

  console.log("loginUserId", loginUserId);
  useEffect(() => {
    var urlpathname = window.location.pathname;
    var roleAllocation = JSON.parse(localStorage.getItem("RoleAllocation"));

    if (roleAllocation && roleAllocation.length > 0) {
      //console.log("roleAllocation", roleAllocation);

      var roleAllocationFilterList = roleAllocation.filter(
        (item) => item.serviceUrl == urlpathname
      );
      //console.log("roleAllocationFilterList", roleAllocationFilterList);
      if (roleAllocationFilterList && roleAllocationFilterList.length > 0) {
        var itemselected = roleAllocationFilterList[0];

        setServiceId(itemselected.serviceId);
        if (itemselected.canAddStatus == true) {
          setCanAdd("block");
        }

        if (itemselected.canEditStatus == true) {
          setCanEdit("block");
        }

        if (itemselected.canDeleteStatus == true) {
          setCanDelete("block");
        }

        if (itemselected.canPdfStatus == true) {
          setCanPdf("block");
        }
        if (itemselected.canViewStatus == true) {
          setCanView("block");
        }
        //console.log("canAdd", canAdd);
      }
    }
  }, []);
  

  const [selecteditem, setSelecteditem] = useState(null);

  const [approvalPopupVisible, setApprovalPopupVisible] = useState(false);

  const [remark, setRemark] = useState("");
  const [loading, setLoading] = useState(false);

  const { sendRequest: updateApprovalStatus } = useHttp();

  const showApprovalPopup = (expense) => {
    // console.log(expense);
    setSelecteditem(expense);
    setApprovalPopupVisible(true);
  };

  const handleRemarkChange = (e) => {
    setRemark(e.target.value);
  };
  const handleApprovalSubmit = (status) => {
    setLoading(true);

    const approvalStatus = status || "";
    // console.log(approvalStatus);
    let data = "";
    var approved = 0;
    var nextlevel = 0;
    if (approvalStatus === "approve") {
      var approved = 1;
    } else if (approvalStatus === "sendNextApprove") {
      nextlevel = 1;
    }

    data = {
      itemId: selecteditem && selecteditem.openingStockId,
      approved: approved,
      approvedBy: parseInt(localStorage.getItem("id")),
      serviceId: serviceId,
      nextlevel: 0,
      orgId: localStorage.getItem("orgId"),
      reamrk: remark,
    };

   console.log("approve stock data", data);

    updateApprovalStatus(
      {
        url: "/api/approveOpeningstock/",
        method: "PUT",
        body: data,
      },
      (data) => {
        toast.success(data);
        setLoading(false);
        setApprovalPopupVisible(false);
        setRemark("");
        FillDetail();
      },
      () => {
        setLoading(false);
      }
    );
  };

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
      top: 50,
      left: 30,
    },
    content: {
      top: "50%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "800px",
      minHeight: "500px",
      height: "80%",
      minHeight: "auto",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const { sendRequest: getDetailView } = useHttp();

  const openModal = (data) => {
    console.log(data);

    const openingStockId = data && data.openingStockId ||0;

    getDetailView(
      {
        url: `/api/openingStock/?orgId=${localStorage.getItem(
          "orgId"
        )}&openingStockId=${openingStockId}`,
      },
      (res) => {
        console.log("Detail View", res);

        setSelectedData(res);
      }
    );

      //  setSelectedData(data);
    setIsModalOpen(true);
  };




  return (
    <>
    <AntModal
        title="Procurement Reciept Approval"
        open={approvalPopupVisible}
        onCancel={() => setApprovalPopupVisible(false)}
        footer={null}
      >
        <label>Remarks:</label>
        <textarea
          rows={3}
          value={remark}
          className="form-control"
          onChange={handleRemarkChange}
        />
        <br />
        <div>
        <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => handleApprovalSubmit("approve")}
            disabled={loading} // Disable button during loading
          >
            {loading ? "Approving..." : "Approve"} {/* Show loading text */}
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            onClick={() => handleApprovalSubmit("disapprove")}
            className="btn btn-sm btn-primary"
            disabled={loading} // Disable button during loading
          >
            {loading ? "Disapproving..." : "Disapprove"}
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => handleApprovalSubmit("sendNextApprove")}
            disabled={loading} // Disable button during loading
          >
            {loading ? "Sending..." : "Send Next Approve"}
          </button>
        </div>
      </AntModal>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-2 my-3">
              {" "}
              &nbsp; &nbsp;Opening Stock{" "}
            </label>{" "}
          </div>
          <div className="col-4"> </div>
          <div className="col-2">
            <button
              type="button"
              className="btn  btn-primary mx-2 my-2"
              onClick={() => {
                props.addForm(true);
                props.sId(serviceId);  
                props.update(false);
              }}
            >
              Add Stock
            </button>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row ">
                      <div className="col-9"> </div>
                   

                      <div className="col-3">
                        {" "}
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          placeholder="Search..."
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                        />{" "}
                        <br />
                      </div>
                    </div>
                    <div className="row">
                      <table className="table table-bordered text-center">
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Doc No</th>
                            <th>Employee Name</th>
                            <th>Approved By</th>
                            <th>Approval</th>
                            <th>View</th>
                        
                   
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems &&
                            currentItems.map((x, i) => (
                              <tr key={i}>
                                <td>{x.openingStockDate}</td>
                                <td>{x.openingStockNo}</td>
                                <td>{x.employeeName}</td>
                                <td>{x.approvedByName}</td>
                           
                                <td>
                                
                                <button
                                  className="btn"
                                  type="button"
                                  onClick={() => showApprovalPopup(x)}
                                  disabled={
                                    x.nextlevel == 1
                                      ? x.allowApproveUserId == loginUserId
                                        ? false
                                        : true
                                      : x.approved == 0 &&
                                        x.reportingId == loginUserId
                                      ? false
                                      : true
                                  }
                                >
                                  {x.approved == 1 ? (
                                    <i
                                      className="fas fa-check-circle"
                                      style={{ color: "green" }}
                                    ></i>
                                  ) : x.approved == 2 ? (
                                    <i
                                      className="fas fa-check-circle"
                                      style={{ color: "red" }}
                                    ></i>
                                  ) : (
                                    <i
                                      className="fas fa-check-circle"
                                      style={{ color: "gray" }}
                                    ></i>
                                  )}
                                </button>
                              </td>
                              <td>
                                    <button
                                      className="btn"
                                      onClick={() => openModal(x)}
                                    >
                                      <i className="fas fa-eye"></i>
                                    </button>
                                  </td>
                              </tr>
                            ))}
                        </tbody>

                     
                      </table>
                    </div>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <Modal isOpen={isModalOpen} style={customModalStyles}>
        <div className="">
          <h3 className="card-title">Opening Stock Details</h3>
          <div className="card-tools text-right">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={() => setIsModalOpen(false)}
            >
              <i className="fas fa-times" />
            </button>
            <hr />
          </div>
        </div>

        {selectedData && (
          <div className="mx-3">
            <div className="row">
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Doc No: {selectedData.openingStockNo}
              </p>
              <p className="col-md-6">
                 Date : {selectedData.openingStockDate}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Employee Name: {selectedData.employeeName}
              </p>
              <p className="col-md-6">
                Approved By Name : {selectedData.approvedByName}
              </p>
            </div>

         
            <h5 className="card-title">Product Details</h5>
            <table className="table table-bordered text-center">
              <thead>
                <tr className="tableheaderrowview">
                  <th>Sr. No</th>
                  <th>Product Type</th>
                  <th>Product Sub Type</th>
                  <th>Product Name</th>
                  <th>Quantity</th>

                  <th>Unit</th>
                  <th>Value</th>
                  <th>Expiry Date</th>
                </tr>
              </thead>
              <tbody>
                {selectedData.productData &&
                  selectedData.productData.map((itm, i) => {
                    return (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{itm.productTypeName}</td>
                        <td>{itm.productSubTypeName}</td>

                        <td>{itm.productName}</td>
                        <td>{itm.quantity}</td>
                        <td>{itm.unitAbbreviation}</td>
                        <td>{itm.value}</td>
                        <td>{itm.expiryDate}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        )}
      </Modal>
    </>
  );
};
export default StockUploadList